import { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { Lock, Sparkles } from 'lucide-react';
import { useProductAccess, getModuleKeyForPath, MODULE_META } from '@/hooks/useProductAccess';

interface ModuleGuardProps {
  children: ReactNode;
  moduleKey?: string;
}

const LOCKED_MESSAGE: Record<string, string> = {
  'fluity-chat':   'Adquira o Fluity Chat para editar e usar este recurso.',
  'fluity-sender': 'Adquira o Fluity Sender para editar e usar este recurso.',
  'fluity-crm':    'Adquira o Fluity CRM para editar e usar este recurso.',
};

/**
 * Shows a read-only banner when the module is not active for the current org.
 * Navigation and viewing work normally — only backend operations are restricted.
 */
export function ModuleGuard({ children, moduleKey: moduleProp }: ModuleGuardProps) {
  const location = useLocation();
  const { isModuleLocked } = useProductAccess();

  const moduleKey = moduleProp ?? getModuleKeyForPath(location.pathname);

  if (!moduleKey || !isModuleLocked(moduleKey)) {
    return <>{children}</>;
  }

  const message = LOCKED_MESSAGE[moduleKey] ?? `Adquira o ${MODULE_META[moduleKey]?.name ?? moduleKey} para usar este recurso.`;

  return (
    <>
      <div className="px-4 sm:px-6 py-2.5 bg-amber-50 border-b border-amber-200/80 flex items-center justify-between gap-4">
        <p className="text-sm text-amber-800">
          <Lock className="inline h-4 w-4 mr-1.5 -mt-0.5 text-amber-600" />
          Visualização. {message}
        </p>
        <button
          className="shrink-0 inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium text-amber-800 bg-amber-100 hover:bg-amber-200 transition-colors"
          onClick={() => {}}
        >
          <Sparkles className="h-3.5 w-3.5" />
          Falar com admin
        </button>
      </div>
      {children}
    </>
  );
}
